export default "__VITE_ASSET__BUw5fUBO__"